import React from 'react';
import { Battery, Wifi, Monitor, CheckCircle } from 'lucide-react';
import './FeaturesSection.css';

const FeaturesSection = () => {
  const keyFeatures = [
    {
      id: 'battery-life',
      icon: <Battery size={48} />,
      title: 'Extended Battery Life',
      description: 'Our RFID systems feature advanced battery backup technology ensuring uninterrupted operation even during power outages.',
      highlights: ['Up to 48 hours backup', 'Smart power management', 'Low battery alerts'],
      bgColor: 'blue'
    },
    {
      id: 'extended-range',
      icon: <Wifi size={48} />,
      title: 'Extended Range',
      description: 'Industry-leading 8-12 meter RFID reading range with offline data storage capabilities for maximum reliability.',
      highlights: ['8-12 meter range', 'Offline data storage', 'Auto-sync when online'],
      bgColor: 'purple'
    },
    {
      id: 'cross-platform',
      icon: <Monitor size={48} />,
      title: 'Cross-Platform Support',
      description: 'Develop once, deploy everywhere. Our solutions work seamlessly across all major platforms and operating systems.',
      highlights: ['Windows', 'Web', 'Android', 'iOS', 'Linux', 'Mac'],
      bgColor: 'green'
    }
  ];

  const aiFeatures = [
    'Predictive Analytics',
    'Intelligent Automation',
    'Smart Insights',
    'Machine Learning Integration'
  ];

  return (
    <section id="features" className="features">
      <div className="features__container">
        <div className="features__header">
          <h2 className="features__title">Key Features & Technologies</h2>
          <p className="features__subtitle">
            Advanced features and cross-platform compatibility ensure our solutions 
            work seamlessly across all your devices and requirements.
          </p>
        </div>

        <div className="features__grid">
          {keyFeatures.map((feature) => (
            <div key={feature.id} className={`features__card features__card--${feature.bgColor}`}>
              <div className="features__card-icon">
                {feature.icon}
              </div>
              <h3 className="features__card-title">{feature.title}</h3>
              <p className="features__card-description">{feature.description}</p>
              <ul className="features__card-highlights">
                {feature.highlights.map((highlight, index) => (
                  <li key={index} className="features__card-highlight">
                    • {highlight}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* AI Integration Preview */}
        <div className="features__ai-preview">
          <div className="features__ai-content">
            <div className="features__ai-text">
              <h3 className="features__ai-title">AI Integration Coming Soon</h3>
              <p className="features__ai-description">
                We're developing advanced AI systems to revolutionize business operations 
                with intelligent automation, predictive analytics, and smart decision-making capabilities.
              </p>
              <div className="features__ai-list">
                {aiFeatures.map((feature, index) => (
                  <div key={index} className="features__ai-feature">
                    <CheckCircle className="features__ai-feature-icon" />
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="features__ai-visual">
              <div className="features__ai-badge">Coming Soon</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
